import React, { createContext } from "react";

export const ApplicantsContext = createContext();

const ApplicantsProvider = props => {
  return <ApplicantsContext.Provider value={{}}>{props.children}</ApplicantsContext.Provider>;
};

export default ApplicantsProvider;
